@if (_templateAttribute.mode !== attributeMode.HIDDEN) {
  <div class="attribute" [formGroup]="form">
    @switch (_templateAttribute.type) {
      <!-- Text field -->
      @case (attributeType.TEXT) {
        <div class="field">
          <mat-form-field appearance="fill">
            <mat-label>
              <sc-dictionary-label [dictionaryKey]="_templateAttribute.labelDictionaryKey"></sc-dictionary-label>
            </mat-label>
            <textarea  name="{{_templateAttribute.key}}" matInput
              [formControlName]="_templateAttribute.key" [readonly]="_templateAttribute.mode === attributeMode.DISABLED"
            [required]="_templateAttribute.required" [maxlength]="4000"></textarea>
          </mat-form-field>
        </div>
      }
      @case (attributeType.STRING) {
        <div class="field">
          <mat-form-field appearance="fill">
            <mat-label>
              <sc-dictionary-label [dictionaryKey]="_templateAttribute.labelDictionaryKey"></sc-dictionary-label>
            </mat-label>
            <input  name="{{_templateAttribute.key}}" matInput [formControlName]="_templateAttribute.key"
              [readonly]="_templateAttribute.mode === attributeMode.DISABLED" [required]="_templateAttribute.required"
              type="text" [maxlength]="4000" />
            </mat-form-field>
          </div>
        }
        @case (attributeType.LABEL) {
          <div class="label-attribute">
            <sc-dictionary-label [dictionaryKey]="_templateAttribute.labelDictionaryKey"></sc-dictionary-label>
          </div>
        }
        <!-- Number field -->
        @case (attributeType.NUMBER) {
          <div class="field">
            <mat-form-field appearance="fill">
              <mat-label>
                <sc-dictionary-label [dictionaryKey]="_templateAttribute.labelDictionaryKey"></sc-dictionary-label>
              </mat-label>
              <input  name="{{_templateAttribute.key}}" matInput [formControlName]="_templateAttribute.key"
                [readonly]="_templateAttribute.mode === attributeMode.DISABLED" [required]="_templateAttribute.required"
                type="number" [maxlength]="50" />
              </mat-form-field>
            </div>
          }
          <!-- Boolean field -->
          @case (attributeType.BOOLEAN) {
            <mat-checkbox  class="form-checkbox" [formControlName]="_templateAttribute.key">
              <sc-dictionary-label [dictionaryKey]="_templateAttribute.labelDictionaryKey"></sc-dictionary-label>
            </mat-checkbox>
          }
          <!-- Boolean_mandatory field -->
          @case (attributeType.BOOLEAN_MANDATORY) {
            <div class="field boolean-mandatory">
              <app-template-attribute-boolean-mandatory [form]="form" [document]="_document"
                [templateAttribute]="_templateAttribute">
              </app-template-attribute-boolean-mandatory>
            </div>
          }
          <!-- Image field -->
          @case (attributeType.PHOTO) {
            <div class="field photo">
              <app-template-attribute-image [document]="_document" [templateAttribute]="_templateAttribute" [metaData]="metaData">
              </app-template-attribute-image>
            </div>
          }
          @case (attributeType.SELECT) {
            @if (selectDefinition!= null) {
              <div class="field select-field">
                <mat-form-field appearance="fill">
                  <mat-label>
                    <sc-dictionary-label [dictionaryKey]="_templateAttribute.labelDictionaryKey"></sc-dictionary-label>
                  </mat-label>
                  <mat-select (selectionChange)="selectionChanged($event)" [required]="_templateAttribute.required"
                    [formControlName]="_templateAttribute.key">
                    @for (o of selectDefinition.options; track o) {
                      <mat-option value="{{o.value}}">
                        {{o.value}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
          }
        }
      </div>
    }
